module.exports = __webpack_public_path__ + "img/plants-7933494_1280.63e8a155.jpg";